
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';

import EventsScreen from './events';
import ListProducts from './ListProducts';
import Alcoholic from './alcoholic';

function Index({setShowHappy}) { 

     const {change, getInitData} = useRefresh();

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [hotdrinks, sethotdrinks] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    
     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, [change]);

     useEffect(() => {
            menus.map((item) => {
            if (item.id === 726) {
                sethotdrinks(item);
            }
        });
    }, [menus]);



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showCocktails={ setShowCocktails} showEvents={ setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div style={{width: '100%', marginBottom: 2, position: 'relative'}}>
                        <img
                            src={require('./assets/TEXT-DRINKS.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: '100%',
                                height: 750,
                                marginTop: 10,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />


                       
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  

                 {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

                
                
                
            </LayoutContent>
            <img
                            src={require('./assets/jugos-lateral.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: '100%',
                                height: 940,
                                marginTop: 100,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                position: 'absolute',
                                right: -258,
                                top: -50,
                              
                                
                            }}
                />
        </div>
    );
}
export default Index;